import config from '../lib/config'
import { MessagesService } from '../services/messages'
import { StreamChatService } from '../services/stream-chat'
import { AuthenticatedGlobalSessionState, GlobalSessionEndpoint } from '../session-state'

import NginBar, { NginBarConstructor } from './ngin-bar'

export class SeBarBootstrapper {

  constructor(
    private document: Document,
    private SeBar: NginBarConstructor,
    private globalSessionEndpoint: GlobalSessionEndpoint,
    private messagesService: MessagesService,
    private streamChatService: StreamChatService,
    private beginCacheSession: () => void,
    private loadAllResources: () => Promise<void>,
    private initializeCSSVars: () => void,
  ) {
  }

  public async run(nbid: string, seTag: string, hasTouch: boolean): Promise<NginBar> {

    this.beginCacheSession()

    const profileReady = this.safeGetSessionProfile()
    const resourcesReady = this.loadAllResources()
    const profile = await profileReady

    await this.initProfile(profile)

    if (this.initElement(nbid, seTag, hasTouch)) {
      await resourcesReady
      this.initializeCSSVars()

      return new this.SeBar({
        elementId: nbid,
        config,
        profile,
      })
    }
  }

  private async safeGetSessionProfile(): Promise<AuthenticatedGlobalSessionState> {
    try {
      return await this.globalSessionEndpoint.fetch().toPromise()
    } catch (err) {
      console.warn('[se-bar SeBarBootStrapper] error retrieving session profile', err)
      return undefined
    }
  }

  private initProfile(profile: AuthenticatedGlobalSessionState): Promise<void> {
    if (!profile) {
      return Promise.resolve()
    }

    this.messagesService.setUser(profile) // starts firebase unread count connection
    this.streamChatService.setUser(profile) // starts stream chat connection
  }

  private initElement(nbid: string, seTag: string, hasTouch) {
    const el = this.document.querySelector(`${seTag}, #${nbid}`)
    if (!el) return false // Exit if no element is found
    el.id = nbid // required for current css -- TODO: update CSS to `se-bar { ... }`
    el.classList.add(hasTouch ? 'has-touch' : 'no-touch')
    return true
  }
}
